import IconSvg from 'src/components/common/ui/IconSvg';

interface LeaderBoardCardProps {
  place: number;
  wallet: string;
  points: number;
}

export default function LeaderBoardCard({ place, wallet, points }: LeaderBoardCardProps) {
  return (
    <div className="grid grid-cols-15 bg-grayscale-800 rounded-[10px] py-[15px] px-[20px] items-center border-[1.5px] border-transparent hover:border-brand-secondary hover:bg-[#FFBD3D1F] transition-all duration-300 mb-2.5">
      <div className="col-span-2">
        <div className="text-lg font-extrabold text-grayscale-400">{place}</div>
      </div>

      <div className="col-span-11">
        <div className="flex items-center gap-5">
          <IconSvg icon="profilePlaceholder" />

          <div className="text-lg text-brand-primary-light">{wallet}</div>
        </div>
      </div>

      <div className="col-span-2">
        <div className="flex items-center justify-end gap-3">
          <IconSvg icon="starM" />

          <div className="text-[24px] font-bold text-grayscale-200">{points}</div>
        </div>
      </div>
    </div>
  );
}
